import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import { Layout } from '@components/common'
import renderSection from './utils'
import configEN from '@config/seo-EN.json'
import configDE from '@config/seo-DE.json'

export default function Page({ page, global: _global }: any) {
  const router = useRouter()
  const locale = (router.locale || router.query.locale) as string
  const isDe = locale === 'de'
  const defaultSeo = isDe ? configDE : configEN
  const hasHeroSection = page?.sections != null && page?.sections?.findIndex((s: any) => s._type === 'superHero') > -1

  const pageTitle = page?.seo?.title ?? page?.title
  const pageDescription = page?.seo?.description ?? page?.description

  return (
    <>
      {(pageTitle || pageDescription) && (
        <NextSeo
          title={pageTitle ?? defaultSeo.defaultTitle}
          description={pageDescription ?? defaultSeo.description}
          languageAlternates={[
            { hrefLang: 'de', href: `${process.env.NEXT_PUBLIC_SITE_URL || 'https://www.myremi.com'}/de${page?.handle?.current ? `/${page.handle.current}` : ''}` },
            { hrefLang: 'en', href: `${process.env.NEXT_PUBLIC_SITE_URL || 'https://www.myremi.com'}/en${page?.handle?.current ? `/${page.handle.current}` : ''}` },
            { hrefLang: 'x-default', href: `${process.env.NEXT_PUBLIC_SITE_URL || 'https://www.myremi.com'}/de${page?.handle?.current ? `/${page.handle.current}` : ''}` },
          ]}
        />
      )}
      {!hasHeroSection && (
        <div className='block h-space26'></div>
      )}
      {
        page?.sections?.map((section: any, index: number) => renderSection(section, index))
      }
    </>
  )
}

Page.Layout = Layout
